import { DAYS_IN_MINUTES, HOURS_IN_MINUTES, MINUTE_IN_MS, WEEK_IN_MINUTES } from "@/utils/time"
import { SnoozeMenuOptions, SnoozeTime, SnoozeTimeOptions } from "@/protocols/snooze"
import { getSavedSnoozeInput } from "@/utils/snoozePersistence"
import { addDays, addHours, addMinutes, addWeeks } from "date-fns"

export const snoozeMenuOptions: SnoozeMenuOptions = {
	minutes: {
		title: "Minuto(s)",
		timeInMinutes: 1
	},
	hours: {
		title: "Hora(s)",
		timeInMinutes: HOURS_IN_MINUTES
	},
	days: {
		title: "Dia(s)",
		timeInMinutes: DAYS_IN_MINUTES
	},
	weeks: {
		title: "Semana(s)",
		timeInMinutes: WEEK_IN_MINUTES
	},
	fullTime: {
		title: "Data personalizada"
	}
}

export const defaultSnoozeTime: SnoozeTime = {
	time: "-",
	fullTime: new Date(),
	timeOption: {
		type: "fullTime",
		title: "-",
		timeInMinutes: 0
	}
}

export const handleInputSnoozeToMilliSeconds = (value: number): number => {
	return value * MINUTE_IN_MS
}

export const getSnoozeTimeInMillisecondsFromFulltimeDateOption = (date: Date): number => {
	const currentTime = new Date()
	const currentTimeInMilliseconds = currentTime.getTime()
	const snoozeAwakeInMilliseconds = date.getTime()

	const snoozeTimeInMilliseconds = snoozeAwakeInMilliseconds - currentTimeInMilliseconds

	return snoozeTimeInMilliseconds
}

export const getSnoozeTimeOptionContent = (timeOption: SnoozeTimeOptions): SnoozeTime["timeOption"] => {
	return {
		type: timeOption,
		...snoozeMenuOptions[timeOption]
	}
}

export const getFullDateByTimeAndOption = (time: string, timeOption: SnoozeTimeOptions) => {
	const formattedTime = Number(time)
	const currentDate = new Date()

	const snoozeMenuOptionsToSnoozeTime: Record<SnoozeTimeOptions, () => Date> = {
		minutes: () => addMinutes(currentDate, formattedTime),
		hours: () => addHours(currentDate, formattedTime),
		days: () => addDays(currentDate, formattedTime),
		weeks: () => addWeeks(currentDate, formattedTime),
		fullTime: () => { return new Date() }
	}
	const snoozeDateHandler = snoozeMenuOptionsToSnoozeTime[timeOption]

	const snoozeDate = snoozeDateHandler()

	return snoozeDate
}

export const getSnoozeTime = (userId: number, instanceId: number): SnoozeTime => {
	const snoozeStorage = getSavedSnoozeInput({
		userId,
		instanceId
	})
	if (snoozeStorage) {
		return {
			time: snoozeStorage.value,
			fullTime: snoozeStorage?.fullTime,
			timeOption: getSnoozeTimeOptionContent(snoozeStorage.snoozeTimeOption)
		}
	}

	return defaultSnoozeTime
}
